CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Organization = require 'app/scripts/models/organization'

class OrganizationList extends CollectionWithHelpers
  model: Organization
  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (organization) -> organization.get('name')?.toUpperCase() || ""

module.exports = OrganizationList
